module.exports = __webpack_public_path__ + "static/media/cb_2.2d1683b7.svg";